import { morphSection } from '@theme/section-renderer';

(function () {
  if (window.__mpBxgyProgressBarInit) return;
  window.__mpBxgyProgressBarInit = true;

  // Keep in sync with the two automatic BXGY discounts in Shopify admin:
  // "Buy 2 Get 1 Free" (3 items -> 1 free) and "Buy 3 Get 2 Free" (5 items -> 2 free).
  var TIERS = [
    { qty: 3, free: 1 },
    { qty: 5, free: 2 }
  ];
  var FINAL_QTY = TIERS[TIERS.length - 1].qty;

  // A discount code and the automatic BXGY discount cannot combine (combinesWith: false
  // on all three discounts in Shopify admin). Once the cart reaches the first BXGY tier,
  // any manually-entered discount code is force-cleared here so the automatic "N free"
  // discount always wins - regardless of whether the code was entered before or after
  // the cart crossed the threshold. This guarantees the savings shown in the progress
  // bar always match the savings actually applied at checkout.
  var DISCOUNT_CLEAR_THRESHOLD = TIERS[0].qty;

  var GIFT_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<rect x="3" y="8" width="18" height="4"></rect>' +
    '<path d="M12 8v13"></path>' +
    '<path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>' +
    '<path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8"></path>' +
    '<path d="M16.5 8a2.5 2.5 0 0 0 0-5C13 3 12 8 12 8"></path>' +
    '</svg>';
  var CHECK_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<polyline points="20 6 9 17 4 12"></polyline>' +
    '</svg>';

  var refreshTimer = null;
  var lastKey = null;
  var enforcingDiscount = false;

  // English plural for "beat": singular only for exactly 1.
  function beatWord(n) {
    return n === 1 ? 'beat' : 'beats';
  }

  // "N free beat(s)" phrase, e.g. "1 free beat" / "2 free beats".
  function freeBeatsPhrase(n) {
    return n + ' free ' + beatWord(n);
  }

  function computeState(qty) {
    qty = qty || 0;

    var reachedIndex = -1;
    for (var i = 0; i < TIERS.length; i++) {
      if (qty >= TIERS[i].qty) reachedIndex = i;
    }

    var caption;
    if (reachedIndex === TIERS.length - 1) {
      var freeCount = TIERS[reachedIndex].free;
      caption = 'You unlocked ' + freeBeatsPhrase(freeCount) + '! 🎉';
    } else {
      var nextTier = TIERS[reachedIndex + 1];
      var toNext = nextTier.qty - qty;
      if (reachedIndex === -1) {
        caption = 'Add ' + toNext + ' more ' + beatWord(toNext) + ' to get ' + freeBeatsPhrase(nextTier.free) + '!';
      } else {
        var prevFree = TIERS[reachedIndex].free;
        caption = 'You unlocked ' + freeBeatsPhrase(prevFree) + '! Add ' + toNext + ' more ' + beatWord(toNext) + ' for ' + freeBeatsPhrase(nextTier.free) + '.';
      }
    }

    var segCount = TIERS.length;
    var segWidth = 100 / segCount;
    var clampedQty = Math.min(qty, FINAL_QTY);
    var fillPct = 0;
    if (clampedQty > 0) {
      var prevThreshold = 0;
      for (var s = 0; s < TIERS.length; s++) {
        var thisThreshold = TIERS[s].qty;
        if (clampedQty >= thisThreshold) {
          fillPct = (s + 1) * segWidth;
          prevThreshold = thisThreshold;
        } else {
          var segProgress = (clampedQty - prevThreshold) / (thisThreshold - prevThreshold);
          fillPct = s * segWidth + segProgress * segWidth;
          break;
        }
      }
    }

    var nodeStates = TIERS.map(function (t, i) {
      if (qty >= t.qty) return 'done';
      if (i === reachedIndex + 1) return 'active';
      return 'pending';
    });

    return { caption: caption, fillPct: fillPct, nodeStates: nodeStates, qty: qty };
  }

  function buildStepper() {
    var el = document.createElement('div');
    el.className = 'mp-bxgy-stepper';

    var caption = document.createElement('div');
    caption.className = 'mp-bxgy-stepper__caption';
    el.appendChild(caption);

    var track = document.createElement('div');
    track.className = 'mp-bxgy-stepper__track';
    var fill = document.createElement('div');
    fill.className = 'mp-bxgy-stepper__fill';
    track.appendChild(fill);

    var nodes = [];
    TIERS.forEach(function (t, i) {
      var node = document.createElement('div');
      node.className = 'mp-bxgy-stepper__node';
      node.style.left = ((i + 1) * (100 / TIERS.length)) + '%';
      node.innerHTML = GIFT_ICON;
      track.appendChild(node);
      nodes.push(node);
    });
    el.appendChild(track);

    var labels = document.createElement('div');
    labels.className = 'mp-bxgy-stepper__labels';
    var labelEls = [];
    TIERS.forEach(function (t, i) {
      var label = document.createElement('div');
      label.className = 'mp-bxgy-stepper__label';
      label.style.left = ((i + 1) * (100 / TIERS.length)) + '%';
      label.textContent = t.qty + ' = ' + t.free + ' free';
      labels.appendChild(label);
      labelEls.push(label);
    });
    el.appendChild(labels);

    el._refs = { caption: caption, fill: fill, nodes: nodes, labels: labelEls };
    return el;
  }

  function ensureStepper(container) {
    var el = container.querySelector(':scope > .mp-bxgy-stepper');
    if (!el) {
      el = buildStepper();
      container.insertBefore(el, container.firstChild);
    } else if (container.firstElementChild !== el) {
      container.insertBefore(el, container.firstChild);
    }
    return el;
  }

  function removeStepper(container) {
    var el = container.querySelector(':scope > .mp-bxgy-stepper');
    if (el) el.parentNode.removeChild(el);
  }

  function applyState(state) {
    var containers = document.querySelectorAll('cart-items-component');
    if (!containers.length) return;
    containers.forEach(function (container) {
      if (!state || state.qty <= 0) {
        removeStepper(container);
        return;
      }
      var el = ensureStepper(container);
      var refs = el._refs;
      if (refs.caption.textContent !== state.caption) {
        refs.caption.textContent = state.caption;
      }
      refs.fill.style.width = state.fillPct + '%';
      state.nodeStates.forEach(function (nodeState, i) {
        var node = refs.nodes[i];
        var label = refs.labels[i];
        if (node.getAttribute('data-state') !== nodeState) {
          node.setAttribute('data-state', nodeState);
          node.innerHTML = nodeState === 'done' ? CHECK_ICON : GIFT_ICON;
        }
        label.setAttribute('data-state', nodeState);
      });
    });
  }

  /**
   * Forcibly clears any manually-entered discount code once the cart has reached
   * DISCOUNT_CLEAR_THRESHOLD items, mirroring the exact request/response shape
   * cart-discount.js's own removeDiscount() uses (POST to Theme.routes.cart_update_url
   * with an updated discount list, then morph each cart-items-component's section from
   * the response), so the automatic BXGY discount is guaranteed to take over instead -
   * no reliance on Shopify's implicit discount-conflict resolution.
   * @param {Object} cart - The cart object from /cart.js.
   * @returns {Promise<Object>} Resolves with the freshest cart object available.
   */
  function clearDiscountCodes(cart) {
    if (enforcingDiscount) return Promise.resolve(cart);
    enforcingDiscount = true;

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (component) {
      var id = component.dataset && component.dataset.sectionId;
      if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
    });

    var url = (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '', sections: sectionIds })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        sectionIds.forEach(function (id) {
          var html = data && data.sections && data.sections[id];
          if (!html) return;
          var component = document.querySelector('cart-items-component[data-section-id="' + id + '"]');
          var isDrawer = !!(component && component.dataset && component.dataset.drawer !== undefined);
          try {
            morphSection(id, html, { mode: isDrawer ? 'hydration' : 'full' });
          } catch (e) {}
        });
        enforcingDiscount = false;
        return data || cart;
      })
      .catch(function () {
        enforcingDiscount = false;
        return cart;
      });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
        var hasDiscountCode = !!(cart && Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0);
        if (qty >= DISCOUNT_CLEAR_THRESHOLD && hasDiscountCode && !enforcingDiscount) {
          return clearDiscountCodes(cart);
        }
        return cart;
      })
      .then(function (cart) {
        var qty = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
        var state = computeState(qty);
        var key = qty + '|' + state.caption;
        lastKey = key;
        applyState(state);
      })
      .catch(function () {});
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 150);
  }

  function init() {
    refresh();
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return (m.target && m.target.closest && m.target.closest('cart-items-component')) ||
          (m.addedNodes && Array.prototype.some.call(m.addedNodes, function (n) {
            return n.nodeType === 1 && (n.matches && n.matches('cart-items-component') || (n.querySelector && n.querySelector('cart-items-component')));
          }));
      });
      if (relevant) scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('cart:refresh', scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
